// Nombre completo de un usuario (nombre + ambos apellidos). Único lugar
// donde se arma, para que el módulo de soporte no muestre nombres a medias.
export const nombreDeUsuario = (u, fallback = "—") => {
  if (!u) return fallback;
  const completo = `${u.nombre || ""} ${u.apellidoPaterno || ""} ${u.apellidoMaterno || ""}`
    .replace(/\s+/g, " ")
    .trim();
  return completo || fallback;
};

export default nombreDeUsuario;
